module.exports = __webpack_public_path__ + "img/arm-left-front.5e7edc47.png";